import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { webSocket } from 'rxjs/observable/dom/webSocket';
import { WebSocketSubject } from 'rxjs/observable/dom/WebSocketSubject';
import { Observable } from 'rxjs/Observable';

import { WebsocketDto } from './websocket.dto';
import { IpcChannelService } from '../ipc-channel/ipc-channel.service';
import { getSelectedAgency, getUserId, State } from '../../state-management/reducers';

@Injectable()
export class WebsocketService {
	public socket: Observable<WebsocketDto>;

	private _ws: WebSocketSubject<any> = webSocket('wss://socket.go-suite.com/ws');

	public constructor(
		private _ipcChannel: IpcChannelService,
		private _store: Store<State>
	) {
		this.socket = this._ws.asObservable();
	}

	public subscribeToChannels(channels: string[]) {
		this._ws.next(JSON.stringify({ request: 'subscribe', to: channels }));
		this.addEmulatedIPCChannelSubscription();
	}

	public sendToSmartBooking(emitted): void {
		this._store.select(getSelectedAgency).take(1).subscribe(agency => {
			this._store.select(getUserId).take(1).subscribe(userId => {
				this._ws.next(JSON.stringify({
					request: 'xena-offer-to-smabo',
					data: emitted,
					recipients: [`agent_${agency.agentId}:user_${userId}`]
				}));
			});
		});
	}

	private addEmulatedIPCChannelSubscription() {
		this.socket.filter(dto => dto.request === 'office-go-suite.ipc-channel').subscribe(dto => {
			this._ipcChannel.publishEmulatedEvent(dto.data);
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/websocket/websocket.service.ts